import { render, staticRenderFns } from "./TextConfig.vue?vue&type=template&id=0c059f84"
import script from "./TextConfig.vue?vue&type=script&lang=js"
export * from "./TextConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports